import { atom } from 'jotai'

export const formularios = atom([]);
export const formularioSeleccionado = atom();